// extracted by mini-css-extract-plugin
module.exports = {"small":"VerticalMargin_small__TrHUj","medium":"VerticalMargin_medium__J2A_f","large":"VerticalMargin_large__fl3y0","extralarge":"VerticalMargin_extralarge__nOFMe"};